import { AxiosConfig } from '../../componentes/axiosConfig';

export class ObterItensAlbumRastreavel {
    constructor() {
        this._axios = (new AxiosConfig()).instanciaAxios();

        this._idContainerAlbum = 'container-album-rastreavel';
        this._idBtnObterAlbum  = 'btn-obter-album-rastreavel';
    }

    executar() {
        const btnLObterExpediente = document.getElementById(this._idBtnObterAlbum);
        if (!btnLObterExpediente) {
            return;
        }

        btnLObterExpediente.addEventListener('click', (evento) => {
            this._obter();
            evento.preventDefault();
        });
    }

    _obter() {
        try {
            const containerExpediente = document.getElementById(this._idContainerAlbum);
            const btnObterExpediente  = document.getElementById(this._idBtnObterAlbum);

            this._axios.get(btnObterExpediente.getAttribute('data-href'))
            .then((response) => {
                containerExpediente.innerHTML = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        }
        catch (error) {
            console.log(error);
        }
    }
}
